import { defineStore } from 'pinia'
import { ref } from 'vue'
import { api } from '@/api/client'

export const useAuthStore = defineStore('auth', () => {
  const isLoggedIn = ref(!!localStorage.getItem('tt_token'))

  async function login(password: string) {
    const res = await api.login(password)
    localStorage.setItem('tt_token', res.token)
    isLoggedIn.value = true
  }

  function logout() {
    localStorage.removeItem('tt_token')
    isLoggedIn.value = false
  }

  return { isLoggedIn, login, logout }
})